import * as Yup from 'yup';

export const formConstants = {
  allowNoTeamShipments: {
    name: 'allowNoTeamShipments',
    label: 'Allow No Team Shipments',
  },
  defaultTeamType: {
    name: 'defaultTeamType',
    label: 'Default Team Type',
  },
};

export const formValidation = Yup.object().shape({
  [formConstants.allowNoTeamShipments.name]: Yup.boolean(),
  [formConstants.defaultTeamType.name]: Yup.string(),
});
